// src/components/Profile/WalletStatsCard.js
import React from "react";
import { useTranslation } from "react-i18next";
import "./ProfileCards.css";
import BarChartComponent from "../Elements/Charts/BarChartComponent";

const WalletStatsCard = ({ stats }) => {
  const { t } = useTranslation();

  if (!stats || typeof stats !== "object") {
    return (
      <section className="summary-card summary-card--user">
        <p className="summary-balance-label">{t("profile.walletActivity")}</p>
        <div className="summary-chart-body summary-chart-empty">{t("profile.noStatsAvailable")}</div>
      </section>
    );
  }

  const data = Object.entries(stats).map(([month, value]) => ({
    month,
    incomes: value.incomes || 0,
    outcomes: value.outcomes || 0,
  }));

  if (data.length === 0) {
    return (
      <section className="summary-card summary-card--user">
        <p className="summary-balance-label">{t("profile.walletActivity")}</p>
        <div className="summary-chart-body summary-chart-empty">{t("profile.noStatsAvailable")}</div>
      </section>
    );
  }

  return (
    <section className="summary-card summary-card--chart">
      <p className="summary-balance-label">{t("profile.walletActivity")}</p>
      <div className="summary-chart-body">
        <BarChartComponent data={data} dataKeyX="month" dataKeyY={["outcomes", "incomes"]} />
      </div>
    </section>
  );
};

export default WalletStatsCard;
